import React from 'react';
import Login from './components/Login';


const LoginContainer = () => {
    return (
        <Login/>
    );
};
export default LoginContainer;